import { render } from "./Navbar1.vue?vue&type=template&id=6a58a54d"
import script from "./Navbar1.vue?vue&type=script&lang=js"
export * from "./Navbar1.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__